import { Shield, BarChart3, Settings, Target } from 'lucide-react';

const DEFAULT_LABELS = {
  necessary: { title: 'Necessary', desc: 'Necessary cookies are required to enable the basic features.' },
  functional: { title: 'Functional', desc: 'Functional cookies help perform certain functionalities.' },
  analytics: { title: 'Analytics', desc: 'Analytical cookies help understand visitor interactions.' },
  performance: { title: 'Performance', desc: 'Performance cookies analyse key performance indexes.' },
  advertisement: { title: 'Advertisement', desc: 'Advertisement cookies provide customised ads.' },
};

const CATEGORY_META = [
  { id: 'necessary', icon: Shield, alwaysActive: true },
  { id: 'functional', icon: Settings },
  { id: 'analytics', icon: BarChart3 },
  { id: 'performance', icon: Target },
  { id: 'advertisement', icon: Target },
];

const pickLabel = (cookies, id, suffix, fallback) => {
  const key = suffix ? `${id}${suffix}` : id;
  return cookies?.[key] || fallback;
};

export const useCookieCategories = (t) => {
  const cookies = t?.cookies;
  return CATEGORY_META.map((meta) => {
    const defaults = DEFAULT_LABELS[meta.id];
    const base = {
      ...meta,
      title: pickLabel(cookies, meta.id, '', defaults.title),
      description: pickLabel(cookies, meta.id, 'Desc', defaults.desc),
    };
    if (meta.alwaysActive) {
      base.alwaysActiveText = pickLabel(cookies, 'alwaysActive', '', 'Always Active');
    }
    return base;
  });
};

export const savePreferencesToStorage = (preferences) => {
  localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
};

export const getPreferencesFromStorage = () => {
  const saved = localStorage.getItem('cookiePreferences');
  return saved ? JSON.parse(saved) : null;
};
